import { BackendLogger } from '../types'

export const ga4Logger: BackendLogger = (eventKey: string, data: any) => {
  window.GA4?.recordEvent(eventKey, data)
}

declare global {
  interface Window {
    GA4: any
  }
}
